<template>
  <v-card class="mt-4">
    <v-toolbar color="primary h5 text-white">{{ item.title }}</v-toolbar>
    <v-card-text class="pa-4">
      <v-simple-table class="table-compact">
        <template v-slot:default>
          <thead>
            <template v-for="(head, i) in item.data.header">
              <th class="" :key="i">
                {{ head }}
              </th>
              <th v-if="item.data.header.length - 1 == i" :key="i + 1">
                Actions
              </th>
            </template>
          </thead>
          <tbody v-if="item.data.body?.items.length > 0">
            <tr v-for="(item, index) in item.data.body?.items" :key="index">
              <template v-for="(el, j) in item?.data">
                <td class="ps-1" :key="j">
                  <div v-html="el"></div>
                </td>
                <td
                  class="ps-1"
                  v-if="item.data.length - 1 == j && item.actions?.length"
                  :key="j + 1"
                >
                  <v-menu
                    left
                    transition="scale-transition"
                    offset-y
                    bottom
                    rounded
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <a
                        v-bind="attrs"
                        v-on="on"
                        class="btn btn-light-light btn-hover-info show poppins min-w-100px min-w-md-110px"
                      >
                        Actions
                        <span class="svg-icon svg-icon-5 m-0">
                          <v-icon small>mdi-chevron-down</v-icon>
                        </span>
                      </a>
                    </template>
                    <v-card
                      class="orders-global-actions poppins py-1"
                      elevation="1"
                    >
                      <div>
                        <div v-for="(action, ind) in item.actions" :key="ind">
                          <v-btn
                            class="w-100 text-left text-dark"
                            @click.prevent="
                              () => showOrdersDialog(action, item?.data[1])
                            "
                            text
                          >
                            {{ action.title }}
                          </v-btn>
                        </div>

                        <!--                        <div>-->
                        <!--                          <v-btn-->
                        <!--                            class="w-100 text-left text-dark"-->
                        <!--                            @click.prevent="-->
                        <!--                              () => showOrdersDialog(item.data, 1)-->
                        <!--                            "-->
                        <!--                            text-->
                        <!--                          >-->
                        <!--                            Invoiced orders-->
                        <!--                          </v-btn>-->
                        <!--                        </div>-->
                        <!--                        <div>-->
                        <!--                          <v-btn-->
                        <!--                            class="w-100 text-left text-dark"-->
                        <!--                            @click.prevent="-->
                        <!--                              () => showOrdersDialog(item.data, 0)-->
                        <!--                            "-->
                        <!--                            text-->
                        <!--                          >-->
                        <!--                            Not invoiced orders-->
                        <!--                          </v-btn>-->
                        <!--                        </div>-->
                        <!-- <div>
                          <v-btn
                            class="w-100 text-left text-dark"
                            @click.prevent="exportFile(data)"
                            text
                          >
                            Export
                          </v-btn>
                        </div> -->
                      </div>
                    </v-card>
                  </v-menu>
                </td>
              </template>
            </tr>
          </tbody>
          <tbody v-else>
            <tr class="h-75px">
              <td
                :colspan="item?.data?.header?.length"
                class="text-center pt-4"
              >
                <span class="second-text">No Data Available!</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
    <v-dialog
      v-model="dialog"
      persistent
      transition="dialog-bottom-transition"
      max-width="1000"
      v-if="itemForChild"
    >
      <div>
        <PopUpDataTableHtmlRender ref="dtb" :item="itemForChild">
          <template #header="{ item, noData }">
            <v-toolbar color="primary h5 text-white">
              {{ itemForChild.title }}
              <v-spacer></v-spacer>
              <v-btn
                icon
                dark
                class="btn btn-sm btn-icon btn-active-light-info"
                @click="
                  () =>
                    exportFile(
                      item?.id,
                      item?.invoiced,
                      item?.export_url,
                      noData
                    )
                "
              >
                <v-icon size="22">mdi-download</v-icon>
              </v-btn>
              <v-btn
                icon
                dark
                class="btn btn-sm btn-icon btn-active-light-info"
                @click="toggleModal"
              >
                <v-icon size="22">mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
          </template>
        </PopUpDataTableHtmlRender>
      </div>
    </v-dialog>
  </v-card>
</template>
<script>
import ApiService from "@/core/services/api.service";
import PopUpDataTableHtmlRender from "./PopUpDataTableHtmlRender.vue";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import Swal from "sweetalert2";
export default {
  components: { PopUpDataTableHtmlRender },
  name: "PopUpTableWithDatatable",
  props: ["item"],
  data: () => ({
    dialog: false,
    itemForChild: null,
  }),
  methods: {
    toggleModal() {
      if (this.dialog) {
        this.itemForChild = null;
      }
      this.dialog = !this.dialog;
    },
    showOrdersDialog(action, id) {
      // const data =
      //   is_invoiced === 1
      //     ? this.item.datatable_header.invoiced_orders
      //     : this.item.datatable_header.not_invoiced_orders;
      this.itemForChild = {
        id,
        ...action,
      };
      this.$nextTick(() => {
        this.toggleModal();
        // this.$refs.dtb.getDataFromApi();
      });
    },
    exportFile(item_id, invoiced = 1, export_url, noData) {
      if (noData) {
        Swal.fire({
          title: "Warning",
          text: "Export data is not available",
          icon: "warning",
        });
        return;
      }

      if (!export_url || !item_id) {
        Swal.fire({
          title: "Warning",
          text: "Please, provide all details",
          icon: "warning",
        });
        return;
      }

      this.$store.commit(SET_PAGE_LOADING, true);

      const payload = {
        id: item_id,
        invoiced,
      };

      if (
        this.$store.getters.getItemForAction &&
        this.$store.getters.getItemForAction.hasOwnProperty("invoice_id")
      ) {
        payload.invoice_id = this.$store.getters.getItemForAction.invoice_id;
      }

      ApiService.post(export_url, payload)
        .then(({ data }) => {
          const link = document.createElement("a");
          link.href = data.file;
          link.download = "Export.csv";
          link.click();
        })
        .finally(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
  },
};
</script>

<style></style>
